import ga from 'react-ga';


const GA_KEY = 'UA-107826746-2';

export const initialize = () => {
  ga.initialize(GA_KEY);
};

export const trackNavLinkClick = (section) => {
  ga.event({
    category: 'Navigation Link',
    action: 'click',
    label: section,
  });
};

export const trackPlayStoreLinkClick = () => {
  ga.event({
    category: 'Download Link',
    action: 'click',
  });
};

export const trackContactLinkClick = (network) => {
  ga.event({
    category: 'Contact Link',
    action: 'click',
    label: network,
  });
}



// WEBPACK FOOTER //
// ./src/services/analytics/index.js